import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { signInWithEmail } from '@/lib/supabase'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Mail, Lock, Loader2 } from 'lucide-react'

export default function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    const { data, error } = await signInWithEmail(email, password)
    
    if (error) {
      setError(error.message)
      setLoading(false)
      return
    }

    if (data?.session) {
      navigate('/dashboard')
    }
    setLoading(false)
  }

  return (
    <div 
      className="min-h-screen w-full flex items-center justify-center px-4"
      style={{ backgroundColor: 'hsl(0 0% 96%)' }}
    >
      <Card 
        className="w-full max-w-md shadow-lg"
        style={{ 
          backgroundColor: 'hsl(0 0% 100%)',
          border: '1px solid hsl(0 0% 90%)'
        }}
      >
        <CardHeader className="space-y-1">
          <div className="flex items-center justify-center mb-4">
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: 'hsl(0 0% 9%)' }}
            >
              <Mail className="w-6 h-6" style={{ color: 'hsl(0 0% 98%)' }} />
            </div>
          </div>
          <CardTitle 
            className="text-2xl text-center"
            style={{ color: 'hsl(0 0% 9%)' }}
          >
            Welcome back
          </CardTitle>
          <CardDescription className="text-center">
            Sign in to access the Email Migration Dashboard
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            {error && (
              <div 
                className="p-3 text-sm rounded-md"
                style={{ 
                  backgroundColor: 'hsl(0 84% 60% / 0.1)',
                  color: 'hsl(0 84% 60%)'
                }}
              >
                {error}
              </div>
            )}
            <div className="space-y-2">
              <Label htmlFor="email" style={{ color: 'hsl(0 0% 9%)' }}>Email</Label>
              <div className="relative">
                <Mail 
                  className="absolute left-3 top-3 h-4 w-4" 
                  style={{ color: 'hsl(0 0% 45%)' }} 
                />
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder="name@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="pl-10"
                  required
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" style={{ color: 'hsl(0 0% 9%)' }}>Password</Label>
              <div className="relative">
                <Lock 
                  className="absolute left-3 top-3 h-4 w-4" 
                  style={{ color: 'hsl(0 0% 45%)' }} 
                />
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10"
                  required
                />
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button 
              type="submit" 
              className="w-full"
              disabled={loading}
              style={{ 
                backgroundColor: loading ? undefined : 'hsl(0 0% 9%)',
                color: 'hsl(0 0% 98%)'
              }}
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  )
}
